import './polyfills'
import g from './globals/variables'
import A11y from './globals/a11y'
import Animations from './components/animations'
import Accordion from './components/accordion'
import Counter from './components/counter'
import Video from './components/video'
import Augl from './components/augl'
import Modal from './components/modal'
import Header from 'components/header'
import Tabs from './components/tabs'
import Filter from './components/filter'
import Customer from './components/customer'
import UlAccords from './components/ulaccords'
import Pamphlets from './components/pamphlets'

import MyPageUsers from './components/mypageUsers'
import UserManagement from './components/mypageUsermanagement'
import Saga from './components/saga'
import FieldControls from './components/fieldControls'
import FormSubmit from './components/forms/RecaptchaFormSubmit'
import HyphenateText from './components/hyphenateText'
import HeroVideo from './components/hero-video'


// recipes website
import NoiSwiper from './components/swiper'
import RecipesAnimations from './components/recipes-animations'
import RecipesLines from 'components/recipes-lines-animations'
import RecipesNavigation from './components/recipes-navigation'
// import NewsletterBlock from './components/newsletter'

// components
g.el.accordions.forEach((target) => Accordion(target))
g.el.counters.forEach((target) => Counter(target))
g.el.videos.forEach((target) => Video(target))
g.el.augl.forEach((target) => Augl(target))
g.el.vidmodal.forEach((target) => Augl(target))
g.el.modal.forEach((target) => Modal(target))
g.el.header.forEach((target) => Header(target))
g.el.tabs.forEach((target) => Tabs(target))
g.el.productFilters.forEach((target) => Filter(target))
g.el.customers.forEach((target) => Customer(target))
g.el.ulAccords.forEach((target) => UlAccords(target))
g.el.saga.forEach((target) => Saga(target))
g.el.fieldControls.forEach((target) => FieldControls(target))
g.el.hyphenText.forEach((target) => HyphenateText(target))
g.el.pamphlets.forEach((target) => Pamphlets(target))
g.el.recipesNavigationMobile.forEach((target) => RecipesNavigation(target))
// g.el.newsletterBlocks.forEach((target) => NewsletterBlock(target))

if (g.form.contact) {
  FormSubmit(g.form.contact)
}

if (document.querySelector('.swiper__container')) {
  NoiSwiper.init()
}

Animations.init()
RecipesAnimations.init()
RecipesLines.init()
A11y.init()
MyPageUsers.init()
UserManagement.init()
HeroVideo.init()

if (process.env.NODE_ENV !== 'production') {
  new EventSource('https://localhost:9000/esbuild').addEventListener('change', (e) => {
    const { added, removed, updated } = JSON.parse(e.data)

    if (!added.length && !removed.length && updated.length === 1) {
      for (const link of document.getElementsByTagName('link') as any) {
        const url = new URL(link.href)

        if (url.host === location.host && url.pathname === updated[0]) {
          const next = link.cloneNode()
          next.href = `${updated[0]}?${Math.random().toString(36).slice(2)}`
          next.onload = () => link.remove()
          link.parentNode.insertBefore(next, link.nextSibling)
          return
        }
      }
    }

    location.reload()
  })
}
